import React, { FC } from 'react';
import classnames from 'classnames';
import Hamburger from 'components/Hamburger';
import { useTheme } from 'contexts/ThemeContext';
import styles from './HeaderHamburger.module.scss';

interface HeaderHamburgerProps {
    isOpened: boolean;
    toggleState: () => void;
    onClosedClick?: () => void;
}

const HeaderHamburger: FC<HeaderHamburgerProps> = (props) => {
    const { isOpened, toggleState, onClosedClick } = props;
    const { theme } = useTheme();

    const handleClick = React.useCallback(() => {
        if (!isOpened && onClosedClick) {
            onClosedClick();
        }
    }, [isOpened, onClosedClick]);

    return (
        <div className={classnames(styles.root, styles[theme], styles.container)} onClick={handleClick}>
            <div className={styles.menu}>
                <Hamburger isActive={isOpened} onToggle={toggleState} />
            </div>
            {isOpened && <div className={styles.backdrop} onClick={toggleState} />}
        </div>
    );
};

export type { HeaderHamburgerProps };
export default HeaderHamburger;
